const initialState = {
  wastemgmt: [],
  housetype: [],
  cookingmethod: [],
  drinkingwater: [],
  wastewatermgmt: [],
  toiletmgmt: [],
  housegarden: [],
  agricultureLandUsage: [],
  agricultureLand: [],
  getState: 0,
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'GET_WASTE_MANAGEMENT_FULFILLED':
      return {
        ...state,
        getState: 2,
        wastemgmt: action.payload.data,
      }
    case 'GET_WASTE_MANAGEMENT_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_WASTE_MANAGEMENT_PENDING':
      return { ...state, getState: 1 }

    case 'GET_WASTEWATER_MANAGEMENT_FULFILLED':
      return {
        ...state,
        getState: 2,
        wastewatermgmt: action.payload.data,
      }
    case 'GET_WASTEWATER_MANAGEMENT_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_WASTEWATER_MANAGEMENT_PENDING':
      return { ...state, getState: 1 }

    case 'GET_TOILET_MANAGEMENT_FULFILLED':
      return {
        ...state,
        getState: 2,
        toiletmgmt: action.payload.data,
      }
    case 'GET_TOILET_MANAGEMENT_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_TOILET_MANAGEMENT_PENDING':
      return { ...state, getState: 1 }

    case 'GET_HOUSETYPE_FULFILLED':
      return {
        ...state,
        getState: 2,
        housetype: action.payload.data,
      }
    case 'GET_HOUSETYPE_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_HOUSETYPE_PENDING':
      return { ...state, getState: 1 }

    case 'GET_HOUSE_GARDEN_FULFILLED':
      return {
        ...state,
        getState: 2,
        housegarden: action.payload.data,
      }
    case 'GET_HOUSE_GARDEN__REJECTED':
      return { ...state, getState: 3 }
    case 'GET_HOUSE_GARDEN__PENDING':
      return { ...state, getState: 1 }

    case 'GET_COOKING_METHOD_FULFILLED':
      return {
        ...state,
        getState: 2,
        cookingmethod: action.payload.data,
      }
    case 'GET_COOKING_METHOD_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_COOKING_METHOD_PENDING':
      return { ...state, getState: 1 }

    case 'GET_COOKING_METHOD_FULFILLED':
      return {
        ...state,
        getState: 2,
        cookingmethod: action.payload.data,
      }
    case 'GET_COOKING_METHOD_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_COOKING_METHOD_PENDING':
      return { ...state, getState: 1 }

    case 'GET_DRINKING_WATER_FULFILLED':
      return {
        ...state,
        getState: 2,
        drinkingwater: action.payload.data,
      }
    case 'GET_DRINKING_WATER_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_DRINKING_WATER_PENDING':
      return { ...state, getState: 1 }

    case 'GET_AGRICULTURAL_LAND_FULFILLED':
      return {
        ...state,
        getState: 2,
        agricultureLand: action.payload.data,
      }
    case 'GET_AGRICULTURAL_LAND_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_AGRICULTURAL_LAND_PENDING':
      return { ...state, getState: 1 }

    case 'GET_AGRICULTURAL_LAND_USAGE_FULFILLED':
      return {
        ...state,
        getState: 2,
        agricultureLandUsage: action.payload.data,
      }
    case 'GET_AGRICULTURAL_LAND_USAGE_REJECTED':
      return { ...state, getState: 3 }
    case 'GET_AGRICULTURAL_LAND_USAGE_PENDING':
      return { ...state, getState: 1 }
    default:
      return state
  }
}

export default reducer
